.stripe-elements {
  font-size: 14px;
}
.stripe-elements .StripeElement {
  font-family: "Roboto", sans-serif;
  background-color: white;
  border-color: #c8c8c8;
  border-radius: 10px;
  border-width: 2px;
  height: 36px;
  padding: 10px 12px;
  border-style: solid;
  box-sizing: border-box;
}

.stripe-elements .custom-input {
  padding: 8px 12px;
}
.custom-input input {
  background-color: white;
  border: none;
  display: block;
  font-size: 1em;
  height: 1.2em;
  line-height: 1.2em;
  margin: 0;
  padding: 0;
  width: 100%;
  font-weight: 500;
}
